export default __webpack_public_path__ + "8052c9e2645a90be5590a03560887fec.jpg";